import { Stack } from '@chakra-ui/react';
import { SectionHeading } from '../../components/SectionHeading';

export function SectionCard({
  title,
  onEdit,
  action,
  children,
  'data-testid': dataTestId,
}: {
  title: React.ReactNode;
  onEdit?: () => void;
  action?: React.ReactNode;
  children: React.ReactNode;
  'data-testid'?: string;
}): React.ReactElement {
  return (
    <Stack gap={3} data-testid={dataTestId}>
      <SectionHeading onEdit={onEdit} editDetails={onEdit != null} action={action}>
        {title}
      </SectionHeading>
      {children}
    </Stack>
  );
}
